import { matchPath, useRoutes } from "react-router-dom";
import React, { useEffect } from "react";
// project import
import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { isExpired, decodeToken } from "react-jwt";
import { LOGIN_AUTH, LOGOUT_AUTH } from '@/store/reducers/auth';
import { get_user_details } from '@/utils/api';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const userModel = useSelector((state) => state.auth.userModel);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    checkLogin();
  }, [userModel.isLogin, location.pathname]);

  function checkLogin() {
    // Supports both BrowserRouter (?a=1) and HashRouter (#/path?a=1) query styles.
    const hashQuery = window.location.hash?.includes('?')
      ? window.location.hash.split('?')[1]
      : '';
    const searchQuery = window.location.search?.startsWith('?')
      ? window.location.search.slice(1)
      : '';
    const params = new URLSearchParams(searchQuery || hashQuery);
    if (params.get('login') === 'success') {
      const accessToken = params.get('access_token');
      const refreshToken = params.get('refresh_token');
      if (accessToken) localStorage.setItem('Token', accessToken);
      if (refreshToken) localStorage.setItem('refresh_token', refreshToken);
      localStorage.setItem('auth_mode', 'sso');

      // Validate token against backend before marking user as logged-in.
      get_user_details((details) => {
        const isProvisioned = Array.isArray(details) && details.length > 0;

        if (!isProvisioned) {
          localStorage.removeItem('Token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('auth_mode');
          dispatch(LOGOUT_AUTH());
          navigate('/login');
          return;
        }

        localStorage.setItem('user_details', JSON.stringify(details[0]));
        window.history.replaceState({}, document.title, window.location.pathname);
        dispatch(LOGIN_AUTH());
        navigate('/recipe-view');
      });
      return;
    }
    const token = localStorage.getItem("Token");
    // Session-cookie auth has no client-side token; the backend enforces expiry
    // via the HttpOnly cookie (a 401 on any call triggers the global logout).
    // So in session mode we treat the "token" as always valid here and let the
    // cookie drive auth — otherwise the missing token reads as "expired" and
    // bounces the user back to /login right after a successful login.
    const isSessionMode = localStorage.getItem("auth_mode") === "session";
    const isMyTokenExpired = isSessionMode ? false : isExpired(token);

    if (!userModel.isLogin) {
      if (
        (location.pathname !== "/login" && location.pathname !== "/") &&
        isMyTokenExpired
      ) {
        LoginRoutes().children.some((item) => item.path === location.pathname)
          ? navigate(location.pathname)
          : navigate("/login");
        localStorage.setItem("lang", "en");
      }
    } else if (isMyTokenExpired && userModel.isLogin) {
      dispatch(LOGOUT_AUTH());
      navigate("/login?reason=expired");
    } else if (
      (location.pathname === "/login" || location.pathname === "/") &&
      !isMyTokenExpired
    ) {
      dispatch(LOGIN_AUTH());
      navigate("/recipe-view");
    } else if (
      !isMyTokenExpired &&
      userModel.isLogin &&
      !MainRoutes().children?.some((item) =>
        matchPath({ path: item.path, end: true }, location.pathname)
      )
    ) {
      dispatch(LOGOUT_AUTH());
      navigate("/login");
    } else {
      dispatch(LOGIN_AUTH());
    }
  }

  return useRoutes([LoginRoutes(), userModel.isLogin && MainRoutes()]);
}
